import { render, staticRenderFns } from "./basics.vue?vue&type=template&id=0c48ae58&scoped=true&"
import script from "./basics.vue?vue&type=script&lang=js&"
export * from "./basics.vue?vue&type=script&lang=js&"
import style0 from "./basics.vue?vue&type=style&index=0&id=0c48ae58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c48ae58",
  null
  
)

export default component.exports